import React from 'react';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import CrazyFont from '@jbhi-fi/lanyard-ui/font/CrazyFont';

export type HeadingFontProps = {
  variant?: HeadingFontVariant;
  as?: keyof React.ReactHTML;
  className?: string;
  children: React.ReactNode;
};

export const HEADING_FONT_VARIANTS = {
  JBCallout: 'JB Callout',
  Crazy: 'Crazy',
  Roboto: 'Roboto',
} as const;

export type HeadingFontVariant = (typeof HEADING_FONT_VARIANTS)[keyof typeof HEADING_FONT_VARIANTS];

const FONT_COMPONENTS: Record<HeadingFontVariant, { component: React.ElementType; defaultAs?: keyof React.ReactHTML }> =
  {
    [HEADING_FONT_VARIANTS.Crazy]: { component: CrazyFont, defaultAs: 'h2' },
    [HEADING_FONT_VARIANTS.Roboto]: { component: 'div', defaultAs: undefined },
    [HEADING_FONT_VARIANTS.JBCallout]: { component: CalloutFont, defaultAs: 'h2' },
  };

export const HeadingFont: React.FC<HeadingFontProps> = ({
  variant = HEADING_FONT_VARIANTS.JBCallout,
  as,
  className,
  children,
}) => {
  const { component: FontComponent, defaultAs } = FONT_COMPONENTS[variant];
  const fontProps: { className?: string; as?: keyof React.ReactHTML } = { className };
  if (defaultAs || as) {
    fontProps.as = (as ?? defaultAs) as keyof React.ReactHTML;
  }
  return <FontComponent {...fontProps}>{children}</FontComponent>;
};
